export default "__VITE_ASSET__DuYxMlbh__"